import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { paths } from '@farmersdog/constants';
import {
  Button,
  GridContainer,
  Text,
  type TextVariant,
  useViewport,
} from '@farmersdog/corgi-x';

import { Picture } from '../Picture';

import { diggingDogSources } from './assets';
import styles from './NotFound.css';

export function NotFound() {
  const viewport = useViewport();
  const [hasMounted, setHasMounted] = useState(false);

  // Workaround to apply the correct variant after the page has been mounted
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const isLargeViewport = hasMounted && viewport.lg;
  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-72'
    : 'heading-52';

  return (
    <>
      <Helmet>
        <title>Not Found | The Farmer’s Dog</title>
      </Helmet>
      <section className={styles.section}>
        <GridContainer>
          <div className={styles.row}>
            <Picture sources={diggingDogSources} alt="digging dog" />
          </div>
          <div className={styles.row}>
            <Text
              className={styles.heading}
              variant={titleVariant}
              color="Kale3"
              as="h1"
              weight="bold"
            >
              This page can’t be found.
            </Text>
            <Text
              className={styles.text}
              variant="article-20"
              color="Charcoal3"
              as="p"
            >
              We’ll dig into it, but try going back for now.
            </Text>
            <div className={styles.cta}>
              <Button type="anchor" href={paths.PATH_HOME}>
                Back to Homepage
              </Button>
            </div>
          </div>
        </GridContainer>
      </section>
    </>
  );
}
